'use strict';

+function ($) {

  var $navbar = $('.site-header .navbar-fixed-top');
  var navbarHeight = $navbar.height();
  var lastWidth = $(window).width();
  var lastPos = 0;
  var delta = 5;

  // hide the navbar when scrolling downwards on mobile (delayed to prevent jumpy behavior on page load with #anchors and stuff)
  window.setTimeout(function () {
    $(window)
    .on('scroll.bc.siteHeader', function () {
      var currentPos = $(this).scrollTop();
      var currentWidth = $(window).width();

      // if the page is busy scrolling then we do not want to interfere (this bool is set to true in scrollto.js)
      if (basecoat.scrollJacking) return false;

      // resizing the window seems to trigger scroll so this negates it
      if (lastWidth != currentWidth) {
        lastPos = currentPos;
        lastWidth = currentWidth;
        return true;
      }

      // hide navbar if scrolling down
      if (currentPos > (lastPos + delta) && currentPos > navbarHeight) {
        $navbar.addClass('navbar-hide');
        lastPos = currentPos;
      // show the navbar if scrolling up OR at the top
      } else if (currentPos < (lastPos - delta) || currentPos < navbarHeight) {
        $navbar.removeClass('navbar-hide');
        lastPos = currentPos;
      }
    });
  }, 1000);

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/site-header.js
// module id = 17
// module chunks = 0